import { jsx } from "react/jsx-runtime";
import { Badge, __css, mergeClasses, tokens } from "@fluentui/react-components";
import { brandTokens } from "../../theme/themes.js";
const useStyles = __css({"chip":{"Huce71":"fz5stix","Bnnss6s":"fi64zpg","st59p4":"f11khh7q","B7ck84d":"f1ewtqcl","Beyfa6y":0,"Bbmb7ep":0,"Btl43ni":0,"B7oj6ja":0,"Dimara":"f44lkw9","Bnt446c":0,"B1hrpyx":0,"Fjva8n":"f1ifyi5","i8kkvl":"f1ufnopg","Be2twd7":"f1ugzwwg","Bg96gwp":"f104wqfl","Bhrd7zp":"fdj6btp","ijz38e":"f1u9dzx2","Ctt3hk":"f19bg87z","F1poyb":"f14bxww4","mbw9mh":"f1sp4c52","Ftih45":"f1wl9k8s","Br0sdwz":"fd1hv5k","nmree":"f1s9zyos","B2zvqh9":"fnny5tc","ebugjb":"f1dzc99s","r59vdv":0,"Budzafs":0,"ck0cow":0,"n07z76":0,"Gng75u":"fielpny","cmx5o7":"f3e8jtw"},"noDot":{"Br0sdwz":"fjookjo"},"success":{"sj55zd":"fhbnykk","De3pzq":"f18r3lq8"},"warning":{"sj55zd":"fhc94cr","De3pzq":"f1ynw2h5"},"danger":{"sj55zd":"f19tbz2r","De3pzq":"f1tmgct3"},"info":{"sj55zd":"fewp24t","De3pzq":"f4xskf5"},"neutral":{"sj55zd":"fgvac7k","De3pzq":"f19zq2xs"}});
function StatusChip({ label, intent, icon, className }) {
  const styles = useStyles();
  const tone = {
    success: styles.success,
    warning: styles.warning,
    danger: styles.danger,
    informative: styles.info,
    brand: styles.info,
    neutral: styles.neutral
  }[intent];
  return /* @__PURE__ */ jsx(
    Badge,
    {
      appearance: "tint",
      shape: "rounded",
      size: "large",
      color: intent === "neutral" ? "subtle" : intent === "informative" ? "informative" : intent === "brand" ? "brand" : intent,
      ...icon ? { icon } : {},
      className: mergeClasses(styles.chip, tone, icon && styles.noDot, className),
      "data-intent": intent,
      children: label
    }
  );
}
export {
  StatusChip
};
//# sourceMappingURL=status-chip.js.map

import "/opt/batiflow/app/packages/ui/dist/components/status-chip/status-chip.griffel.css";